
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import { Dialog } from 'vant';
import { Field } from 'vant';
import confirmBox from '../components/Confirm.vue';
import Empty from '../components/Empty.vue';
import tipBox from '../components/TipBox.vue';
import BM from '../components/js/common';

import * as Api from '../service/Api';

import share from '../components/js/share';
import QRCode from 'qrcodejs2'
export default {
data() {
return {
operatId:"",
meetingDetail:{},
showToast:false,
canBaoming:true,
maxseat:100,
activeNames: ['1'],
ndata:2,
qrcodeshow:false,
index: 0,
toastText:"",
showDes:true,
meetfee:"",
biz: "86",
phone:"",
condition:"",
areaNum:"",
showmeet:false,
toastText:"",
versms:"",
showproDes:true,
teleArr: [{
"intl_tele_code": "86",
"name": "中国",
"short_name": "CN +86"
},
{
"intl_tele_code": "81",
"name": "日本",
"short_name": "JP +81"
},
{
"intl_tele_code": "852",
"name": "香港",
"short_name": "HK +852"
},
{
"intl_tele_code": "853",
"name": "澳门",
"short_name": "MO +853"
},
{
"intl_tele_code": "886",
"name": "台湾",
"short_name": "TW +886"
},
{
"intl_tele_code": "82",
"name": "韩国",
"short_name": "KR +82"
},
{
"intl_tele_code": "1",
"name": "美国",
"short_name": "US +1"
},
{
"intl_tele_code": "44",
"name": "英国",
"short_name": "UK +44"
},
{
"intl_tele_code": "49",
"name": "德国",
"short_name": "DE +49"
},
{
"intl_tele_code": "33",
"name": "法国",
"short_name": "FR +33"
},
{
"intl_tele_code": "66",
"name": "泰国",
"short_name": "TH +66"
},
{
"intl_tele_code": "65",
"name": "新加坡",
"short_name": "SG +65"
},
{
"intl_tele_code": "60",
"name": "马来西亚",
"short_name": "MY +60"
},
{
"intl_tele_code": "61",
"name": "澳大利亚",
"short_name": "AU +61"
}
],
sms:"",
wechat:"",
name:"",
stepNum:"",
getcodeTxt:"",
cansend:true,
bacheight:"",
wxcode:"",
orderId:"",
showdHeader:true,
weekend:false,
contacttypelist:[{"val":1,"desc":"EMAIL"},{"val":2,"desc":"WECHAT"},{"val":3,"desc":"LINE"},{"val":4,"desc":"WHATSAPP"},{"val":5,"desc":"FACEBOOK"},{"val":6,"desc":"INSTAGRAM"},{"val":7,"desc":"TWITTER"},{"val":8,"desc":"WEIBO"},{"val":9,"desc":"KAKAO_TALK"},{"val":10,"desc":"TELEGRAM"}],
contacttypeval:2,
ifproject:false,
}
},
computed: {
},
created(){
if(window.wx===undefined){
let script=document.createElement('script');
let head=document.getElementsByTagName('head')[0];
script.type='text/javascript';
script.charset='UTF-8';
script.src='https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
head.appendChild(script);
}
this.$vux.loading.show({
text: '加載詳情中',
})
this.operatId = this.$route.query.id;
this.weekend = this.$route.query.weekend;
this.getMeeting();

var ua = navigator.userAgent.toLowerCase();










let cover=document.body.clientWidth;
var bacheight=parseInt(cover/2.15)+"px";
this.bacheight=bacheight;
},
mounted(){




},
methods:{
downQrcode(){
let myCanvas = document.getElementById('qrcodeBox').getElementsByTagName('canvas');

let a = document.createElement("a")

a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')

a.download = "谷町君支付二維碼.png"

a.click()

that.toastText="正在下載";
that.showToast = true;
},
getcontact(){
let that = this;
this.$ajax.get(Api.contacttypelist)
.then(function (res) {

if(res.data.code == '200' && res.data.data.length){
that.contacttypelist=res.data.data
}else{
that.contacttypelist=[{"val":1,"desc":"EMAIL"},{"val":2,"desc":"WECHAT"},{"val":3,"desc":"LINE"},{"val":4,"desc":"WHATSAPP"},{"val":5,"desc":"FACEBOOK"},{"val":6,"desc":"INSTAGRAM"},{"val":7,"desc":"TWITTER"},{"val":8,"desc":"WEIBO"},{"val":9,"desc":"KAKAO_TALK"}]
}
})
.catch(function (err) {
that.contacttypelist=[{"val":1,"desc":"EMAIL"},{"val":2,"desc":"WECHAT"},{"val":3,"desc":"LINE"},{"val":4,"desc":"WHATSAPP"},{"val":5,"desc":"FACEBOOK"},{"val":6,"desc":"INSTAGRAM"},{"val":7,"desc":"TWITTER"},{"val":8,"desc":"WEIBO"},{"val":9,"desc":"KAKAO_TALK"}]
});
},
beforeClose(action, done){
if (action === 'confirm') {
let that=this;
let wxLoginCode="";
var ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {
wxLoginCode=this.wxcode;
}else{
wxLoginCode="";
}
if(!this.name || !this.wechat){
done(false);
this.toastText="請填寫您的姓名及對應賬號";
this.showToast = true;
return;
}else{
this.$vux.loading.show({
text: '請求中',
})
this.$ajax.post(Api.enterApply,{  //params参数必写 , 如果没有参数传{}也可以
"biz":that.biz,
"bookSeat":that.stepNum,
"captcha": that.versms,
"cost": that.meetfee,
"meetingId": that.operatId,
"mobile": that.phone,
"name": that.name,
"wechat": that.wechat,
"wxLoginCode": wxLoginCode,
"contactType": that.contacttypeval
})
.then(function (res) {
that.$vux.loading.hide();
if(res.data.code==200){
done();
let nowData=res.data.data;
that.orderId=nowData.orderId;
if(nowData.code==100){
if(nowData.mweb_url){
that.qrcodeshow=true;
setTimeout(function(){
let ele=document.getElementById('qrcodeBox');


var qrcode = new QRCode(ele, {
text: res.data.data.mweb_url,
width: 200,
height: 200,
colorDark : '#000000',
colorLight : '#ffffff',
correctLevel : QRCode.CorrectLevel.H
});
},100)
}else{
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
}
}else{
that.onBridgeReady(nowData.appId,nowData.timeStamp,nowData.nonceStr,nowData.packageValue,nowData.paySign);
}
}
}else{
that.toastText="此次不需要支付，您已成功報名。";
that.showToast = true;
that.$router.push({path: '/success'});
}
}else if(res.data.code==500){
done(false);
that.toastText=res.data.msg;
that.showToast = true;
}else{
done(false);
that.toastText="請求失敗請稍後重試";
that.showToast = true;
that.$vux.loading.hide();
}
})
.catch(function (err) {
done(false);
that.toastText="請求失敗請稍後重試";
that.showToast = true;
that.$vux.loading.hide();
});
}
} else {
done();
}
},
getMeeting(){
var that=this;
var timestamp = Date.parse(new Date());
timestamp = timestamp / 1000;
this.$ajax.get(Api.meetDetail + "/" + timestamp + "/" + that.operatId)
.then(function (res) {
if(res.data.code == '200'){
if(res.data.data){
that.$vux.loading.hide();
that.meetingDetail= res.data.data,
that.ndata=1;
if (res.data.data.meetingType!=2 && res.data.data.meetingModel==0 &&res.data.data.meetingBookingSeat <= res.data.data.registerTotal){
that.toastText="此分享會已滿員停止報名，請報名其他場次的分享會。";
that.showToast = true;
that.canBaoming=false;
that.ifproject=false;
}else{
if (res.data.data.meetingType!=2 &&!res.data.data.meetingModel) {
that.maxseat= res.data.data.meetingBookingSeat - res.data.data.registerTotal
that.ifproject=false;
} else {
if(res.data.data.meetingType==2){
that.ifproject=true;
}
that.maxseat= 200;
}
}
}else{
that.ndata=0;
that.$vux.loading.hide();
that.toastText="加載失敗，請稍後重試。";
that.showToast = true;
}
}else{
that.ndata=0;
that.$vux.loading.hide();
that.toastText="加載失敗，請稍後重試。";
that.showToast = true;
}
})
.catch(function (err) {
that.$vux.loading.hide();
that.toastText="加載失敗，請稍後重試。";
that.showToast = true;
that.ndata=0;
});
},
payVerify(){
let that=this;
this.$vux.loading.show({
text: '正在驗證..',
})
this.$ajax.get(Api.ifpay, {
params: {
orderId:that.orderId
}
})
.then(function (res) {
that.$vux.loading.hide();
if (res.data.code == 40001) {
that.toastText="服務更新中，請稍後重試";
that.showToast = true;
} else if (res.data.code == 200) {
if(res.data.data){
that.toastText="支付成功";
that.showToast = true;
that.$router.push({path: '/success'});
}else{
that.toastText="支付失敗，請稍後重試";
that.showToast = true;
that.qrcodeshow=true;
}
} else {
that.toastText="請求失敗，請稍後重試";
that.showToast = true;
}
})
.catch(function (err) {
that.$vux.loading.hide();
that.toastText="請求失敗，請稍後重試";
that.showToast = true;
});
},
totop(){
window.scrollTo(0, 0);
},
tolist(){
this.$router.push({
path: '/list'
});
},
payPage(){
let that=this;
let wxLoginCode="";
var ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {
wxLoginCode=this.wxcode;
}else{
wxLoginCode="";
}
if(!this.phone || !this.name || !this.wechat){
this.showmeet=true;
this.toastText="請完善信息";
this.showToast = true;
return;
}else{
this.$vux.loading.show({
text: '請求中',
})
this.$ajax.post(Api.enterApply,{  //params参数必写 , 如果没有参数传{}也可以
"biz":that.biz,
"bookSeat":that.stepNum,
"captcha": that.versms,
"cost": that.meetfee,
"meetingId": that.operatId,
"mobile": that.phone,
"name": that.name,
"wechat": that.wechat,
"wxLoginCode": wxLoginCode,
"contactType": that.contacttypeval
})
.then(function (res) {
that.$vux.loading.hide();
if(res.data.code==200){
let nowData=res.data.data;
that.orderId=nowData.orderId;
if(nowData.code==100){
if(nowData.mweb_url){
that.qrcodeshow=true;
setTimeout(function(){
let ele=document.getElementById('qrcodeBox');


var qrcode = new QRCode(ele, {
text: res.data.data.mweb_url,
width: 200,
height: 200,
colorDark : '#000000',
colorLight : '#ffffff',
correctLevel : QRCode.CorrectLevel.H
});
},100)
}else{
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
}
}else{
that.onBridgeReady(nowData.appId,nowData.timeStamp,nowData.nonceStr,nowData.packageValue,nowData.paySign);
}
}
}else{
that.toastText="此次不需要支付，您已成功報名";
that.showToast = true;
that.$router.push({path: '/success'});
}
}else{
that.showmeet=true;
that.toastText="請求失敗，請稍後重試";
that.showToast = true;
}
})
.catch(function (err) {

that.toastText="請求失敗，請稍後重試";
that.showToast = true;
that.$vux.loading.hide();
});
}
},
onBridgeReady(aid,ts,ns,pv,ps){
let that=this;
WeixinJSBridge.invoke(
'getBrandWCPayRequest', {
"appId":aid,     //公众号名称，由商户传入
"nonceStr":ns, //随机串
"package":pv,
"signType":"MD5",         //微信签名方式：
"paySign":ps,//微信签名
"timeStamp":ts         //时间戳，自1970年以来的秒数
},
function(res){

if (res.err_msg == 'get_brand_wcpay_request:ok') {
that.toastText="支付成功";
that.showToast = true;
that.$router.push({path: '/success'});

} else {

that.toastText="支付失敗";
that.showToast = true;
}
});
},

numChange(e){

let nowNum = e.detail;
let fee;
if(this.condition==0){
fee = e * this.meetingDetail.cost
}else{
if (e <= this.condition){
fee=0;
}else{
fee = (e - this.condition) * this.meetingDetail.cost;
}
}
this.meetfee=fee;
},
regetcode(){
let that = this;
let cap= new window.TencentCaptcha("2044603328",function(res){

if(res.ret === 0){
let ticket = res.ticket;
let randstr = res.randstr;

that.toastText="驗證成功正在發送驗證碼";
that.showToast = true;
that.$ajax.post(Api.safeCodeUrl,{
"biz":that.biz,
"mobile":that.phone.toString(),
"meetingId":that.operatId,
"ticket": ticket,
"randstr": randstr,
}
)
.then(function (res) {
if(res.data.code == '200'){
that.toastText="發送成功";
that.showToast = true;
let nTime = 60;
that.cansend = false;
that.getcodeTxt = '已發送（59s）';
nTime = 59;
let iTime = setInterval(function() {
nTime--;
if (nTime <= 0) {
clearInterval(iTime);
that.cansend = true;
} else {
that.getcodeTxt = '已發送（' + nTime + 's）';
}
}.bind(this), 1000);
}else{
if(res.data.msg){
that.toastText=res.data.msg;
}else{
that.toastText="短信發送失敗，請稍後重試。";
}
that.showToast = true;
}
})
.catch(function (err) {
that.toastText="短信發送失敗，請稍後重試。";
that.showToast = true;
});
}
});
cap.show();
},
contactus(){
this.meetfee=0;
this.showmeet=true;
this.condition=false;
this.ifproject=true;
this.stepNum=1;
},
applyPhone(){

var that = this;
if(!this.phone){
that.toastText="請輸入手機號";
that.showToast = true;
this.$refs['input'].focus()
}else{
this.$ajax.get(Api.applyOne + "/" + that.meetingDetail.id + "/" + that.biz + "/" + that.phone)
.then(function (res) {
if (res.data.code == 40001) {
that.toastText="服務更新中";
that.showToast = true;
} else if (res.data.code == 200) {
that.toastText="驗證成功";
that.showToast = true;
that.wechat=that.phone;
that.name="";
that.versms="";
that.stepNum=1;
if (res.data.data.condition > 0) {
that.meetfee=0;
that.condition=res.data.data.condition;
that.getSms();
}else{
that.meetfee=that.meetingDetail.cost;
that.showmeet=true;
that.condition=res.data.data.condition;
}

} else {
that.toastText="請求失敗請稍後重試";
that.showToast = true;
}
})
.catch(function (err) {

that.toastText="加載失敗";
that.showToast = true;
});
}
},
getCostdes(){
Dialog.alert({
title: '費用說明',
message: '參會費是為了控制到場率及參會人員的質量。谷町君會為您配備專屬咨詢顧問，給真正的意向客戶提供最高效周到的一對一服務。\n請您報名前充分理解上述內容，參會費一經付款恕不退還。費用為日元單位，會以支付時的匯率自動為您換算成人民幣。\n是否免單請輸入手機號驗證。',
showCancelButton:false,
messageAlign:"left",
confirmButtonText:"我已了解",
confirmButtonColor:"#44c2b8"
}).then(() => {

});
},
getwechat(event){
if (event.detail.value){
this.wechat=this.data.phone;
}else{
return;
}
},
getSms(){
let that = this;
let cap= new window.TencentCaptcha("2044603328",function(res){

if(res.ret === 0){
let ticket = res.ticket;
let randstr = res.randstr;

that.toastText="驗證成功，請注意查收驗證碼";
that.showToast = true;
that.showmeet=true;
that.$ajax.post(Api.safeCodeUrl,{
"biz":that.biz,
"mobile":that.phone.toString(),
"ticket": ticket,
"meetingId":that.operatId,
"randstr": randstr,
})
.then(function (res) {

if(res.data.code == '200'){
that.toastText="發送成功";
that.showToast = true;
}else{
that.toastText="發送失敗，請稍後重試。";
that.showToast = true;
}
})
.catch(function (err) {
that.toastText="發送失敗，請稍後重試。";
that.showToast = true;
});
}
});
cap.show();
},
backHome(){
this.$router.push({
path: '/list'
});
},
phoneChange(e){
this.setData({
phone: e.detail
})
},
bindPickerChange(e) {
this.setData({
index: e.detail.value,
biz: this.data.teleArr[e.detail.value].intl_tele_code
})

},
getCostRule(){
Dialog.confirm({
title: '收費規則',
message: '收費規則如下：未報名過分享會的普通會員為預訂席位*參會費，參加過分享會的可免費參加（限一位），普通黑卡2名免費，超級黑卡3名免費，璀璨黑卡4名免費，至尊黑卡5名免費。超過名額的按普通收費規則收取相應費用。',
zIndex:3000,
showCancelButton: false,
messageAlign: "left",
confirmButtonText: "我已了解",
confirmButtonColor:"#44c2b8"
}).then(() => {

})
}
},
components: {
confirmBox,
Empty,
tipBox,
XButton ,XInput,Toast,Group, XHeader, CheckIcon,Cell, CellBox
}
}



// WEBPACK FOOTER //
// ./src/pages/Detail.vue